<template>
  <div class="com-box" @click="closeSignup">
    <div class="com">
      <div class="com-body" @click.stop.prevent>
        <div class="info-item">
          <div class="f fc fbt" style="margin-bottom:15px;">
            <div class="info-title" style="font-weight:bold;margin-bottom:0;">填写个人信息</div>
            <img
              src="https://j.weizan.cn/youxiang/live-close.png"
              class="close-icon"
              @click.stop.prevent="closeSignup"
            />
          </div>

          <div class="info-input f fc">
            <img src="https://j.weizan.cn/youxiang/people.png" class="info-icon" />
            <van-field v-model="name" clearable placeholder="请输入姓名" />
          </div>
        </div>
        <div class="info-item">
          <div class="info-title">手机号码</div>
          <div class="info-input f fc">
            <img src="https://j.weizan.cn/youxiang/phone.png" class="info-icon" />
            <van-field v-model="phone" center maxlength="11" type="number" placeholder="请输入手机号码">
              <template #button>
                <div class="code-tip" @click="getCode" v-if="!codeSended">获取验证码</div>
                <div class="code-tip" v-else>{{codeTime}}s后重新获取</div>
              </template>
            </van-field>
          </div>
        </div>

        <div class="info-item" v-show="codeFlag">
          <div class="info-title">验证码</div>
          <div class="info-input f fc">
            <img src="https://j.weizan.cn/youxiang/phone.png" class="info-icon" />
            <van-field v-model="code" placeholder="请输入验证码" maxlength="4" />
          </div>
        </div>
        
        <div class="info-item">
          <div class="info-title">所在区域</div>
          <div class="area-set">
            <div class="info-input2 f fc bb1" @click="choiceArea">
              <van-icon name="friends-o" class="info-icon" size="18"/>
              <van-field v-model="areaName" center maxlength="11" placeholder="请选择区域"  right-icon="arrow" readonly>
              </van-field>
            </div>
            <div class="info-input2 f fc">
              <van-icon name="wap-home-o" class="info-icon" size="18"/>
              <van-field v-model="areaNameDeatil" center maxlength="20" placeholder="请输入详细地址">
                <template #extra>
                  <span style="color:#b0b0b0">{{areaNameDeatil.length}}/20</span>
                </template>
              </van-field>
            </div>
          </div>
        </div>
        <div class="info-item">
          <van-field
            v-model="remark"
            rows="1"
            autosize
            maxlength="50"
            type="textarea"
            placeholder="您希望解决的问题和需求是？（选填）"
            class="input-area"
          />
        </div>
        <van-checkbox v-if="agreeement.showAgreement" class="checkbox" v-model="checked" shape="square">
          <span class="checkbox-text">我已阅读并同意
            <span @click.stop="handleShowProtocol">
              {{agreeement.buttonContent ? '《' + agreeement.buttonContent + '》' : '《用户隐私协议》'}}
            </span>
          </span>
        </van-checkbox>

        <div class="signup-number" v-if="enrollNum>-1">
          已报名
          <span style="color:#003078">{{enrollNum}}</span>人
        </div>

        <div class="op-btn" @click="submit" v-if="enrollStatus!=='enrolled'">立即报名</div>
        <div class="op-btn" @click="buyNow" v-else>立即购买</div>
      </div>
    </div>
    <van-popup class="protocol" lock-scroll v-model="showProtocol" round position="bottom" :style="{ height: '60%' }">
      <div class="protocol-title">
        <van-icon name="arrow-left" class="back" @click.stop="closeProtocol"/>
        <div class="title">{{agreeement.buttonContent || '用户隐私协议'}}</div>
      </div>
      <div class="protocol-contant" v-html="agreeement.agreementContent"></div>
    </van-popup>
    <van-popup
      v-model="popupAreaShow"
      round
      position="bottom"
      :style="{ height: '308px' }"
      get-container="body"
    >
      <van-area
        :area-list="areaList"
        :value="areaCode"
        @confirm="confirmArea"
        @cancel="popupAreaShow = false"
      >
      </van-area>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { isChinese } from "./../utils/tools";
import { areaList } from "./../utils/area.js";
export default {
  props: {
    enrollNum: {
      type: Number,
      default: -1,
    },
    // 调用弹窗的营销活动
    callSrouce: {
      type: String,
      default: "", //collect_like 、act_signup、card_signup
    },
  },
  data() {
    return {
      showProtocol: false,
      agreeement: {},
      checked: true,
      name: "",
      phone: "",
      code: "",
      remark: "",
      codeInterval: null,
      codeSended: localStorage.getItem("codeSended") === "true" || false,
      codeSendedTime:
        localStorage.getItem("codeSendedTime") || new Date().getTime(),
      codeTime: Number(localStorage.getItem("codeTime")),
      timeInterval: null,
      enrollStatus:localStorage.getItem("setEnrollStatus"),
      popupAreaShow: false, //省市区选择
      areaList: areaList, // 省市区数据列表
      areaCode: "", // 记录选中省市区code值(回显数据)
      areaName: "", // 记录选中省市区name值(回显数据)
      areaNameDeatil: "", // 详细地址
    };
  },

  computed: {
    // ...mapState(["enrollStatus"]),
    codeFlag: function () {
      return this.phone.length == 11;
    },
  },
  created() {
    this.areaNameDeatil = "";
    this.areaName = "";
    var location = JSON.parse(localStorage.getItem("location")) || null;
    console.log(location);
    console.log(location.data);
    if(location){ 
      var data = location.data;
      var areaName = "";
      if(data.province){
        areaName = areaName + data.province;
      }
      if(data.city){
        areaName = areaName + "-" + data.city;
      }
      if(data.district){
        areaName = areaName + "-" + data.district;
      }
      this.areaName = areaName;
    }
    this.getAgreement()
    if (
      this.codeSended &&
      new Date().getTime() < Number(this.codeSendedTime) + 60000
    ) {
      this.calcCodeTime();
    } else {
      this.codeSended = false;
    }
  },
  destroyed() {
    clearInterval(this.timeInterval);
  },
  methods: {
    // 获取用户协议
    async getAgreement () {
      let actId = this.$route.query.act_id || localStorage.getItem("act_id")
      let res = await this.$http.post(`/v1/home/get_agreement?actId=${actId}`);
      if (res.code === 0) {
        console.log(res.data);
        this.agreeement = res.data
      }
    },
    handleShowProtocol () {
      this.showProtocol = true
    },
    closeProtocol () {
      this.showProtocol = false
    },
    buyNow() {
      this.$emit("buyNow");
    },
    submit() {
      if (!this.checked && this.agreeement.showAgreement) {
        this.$toast(`如需报名活动，请先阅读并同意${this.agreeement.buttonContent ? '《' + this.agreeement.buttonContent + '》' : '《用户隐私协议》'}`);
        return false;
      }
      if (!isChinese(this.name)) {
        this.$toast("姓名仅可输入中文");
        return false;
      }
      if (!this.code) {
        this.$toast("请输入验证码");
        return false;
      }
      if (!this.areaName) {
        this.$toast("请选择所在区域");
        return false;
      }
      if (!this.areaNameDeatil || (this.areaNameDeatil&&this.areaNameDeatil.length<5)) {
        this.$toast("请完整填写地址，不少于5个字");
        return false;
      }
      this.$http
        .post("/v1/home/enroll", {
          activityId: localStorage.getItem("act_id"),
          channel: "enrollment",
          code: this.code,
          name: this.name,
          phone: this.phone,
          suggest: this.remark,
          area: this.areaName,
          addr: this.areaNameDeatil,
        })
        .then((res) => {
          if (res.code === 0) {
            this.$emit("signupSuccess", this.callSrouce);
          }
        });
    },
    getCode() {
      if (!this.phone) {
        return this.$toast(`请输入手机号码后再发送！`);
      }
      if (!/^(?:(?:\+|00)86)?1\d{10}$/.test(this.phone)) {
        return this.$toast(`请输入正确的手机号码！`);
      }
      if (this.codeSended) {
        return this.$toast(`请${this.codeTime}后再发送！`);
      }
      this.$http
        .post("/v1/home/send_code", {
          phone: this.phone,
          use: "enroll",
        })
        .then((res) => {
          if (res.code === 0) {
            this.$toast("发送成功");
            this.codeTime = 60;
            this.codeSendedTime = new Date().getTime();
            localStorage.setItem("codeSendedTime", new Date().getTime());
            localStorage.setItem("codeSended", true);
            this.calcCodeTime();
          }
        });
    },
    calcCodeTime() {
      this.codeSended = true;
      this.timeInterval = setInterval(() => {
        this.codeTime = parseInt(
          (new Date(Number(this.codeSendedTime)).getTime() +
            60000 -
            new Date().getTime()) /
            1000
        );

        if (this.codeTime > 0) {
          localStorage.setItem("codeTime", --this.codeTime);
        } else {
          localStorage.setItem("codeSended", false);
          localStorage.removeItem("codeSendedTime");
          this.codeSended = false;
          clearInterval(this.timeInterval);
        }
      }, 1000);
    },
    closeSignup() {
      this.$emit("closeSignup");
    },
    choiceArea(){
      // Area 省市区
      this.popupAreaShow = true;
      this.areaCode = "110000";
    },
    // Area 省市区 点击右上方完成按钮
    confirmArea(area) {
      this.areaName = "";
      var areaName = "";
      console.log(area);
      if(area&&area.length>0){
        if(area[0]){
          areaName = areaName + area[0].name;
        }
        if(area[1]){
          areaName = areaName + "-" +  area[1].name;
        }
        if(area[2]){
          areaName = areaName + "-" +  area[2].name;
        }
      }
      this.areaName = areaName;
      this.popupAreaShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
.protocol {
  .protocol-title {
    font-size: 16px;
    font-weight: 700;
    margin: 20px 0 10px 0;
    display: flex;
    .title {
      flex: 1;
      text-align: center;
    }
  }
  .protocol-contant {
    font-size: 14px;
    max-height: 85%;
    overflow: auto;
    padding: 5px 10px 5px 5px;
    /deep/ img {
      width: 100%;
      height: 100%;
    }
  }
}
.signup-number {
  text-align: center;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(184, 184, 184, 1);
}
.com-box {
  z-index: 1000;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  left: 0;
  bottom: 0;
}
.com {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  border-radius: 15px 15px 0px 0px;
  .com-header {
    position: relative;
    height: 58px;
    .bg-img {
      position: absolute;
      right: 0;
      top: 0;
      width: 151px;
      height: 190px;
    }
    .time-area {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 24px;
    }
    .time {
      width: 19px;
      height: 18px;
      background: rgba(0, 27, 68, 1);
      border-radius: 2px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 18px;
      text-align: center;
      margin: 0 5px;
    }
  }
  .com-body {
    background: rgba(255, 255, 255, 1);
    border-radius: 15px 15px 0px 0px;
    padding: 12px 16px 0;
    .info-item {
      margin-bottom: 15px;
      .input-area {
        -webkit-user-select: text;
        background: #f5f6f7;
        border-radius: 5px;
      }
      .info-title {
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(53, 53, 53, 1);
        margin-bottom: 15px;
      }
      .area-set{
        border: 1px solid #b0b0b0;
        border-radius: 5px;
        .info-input2 {
          overflow: hidden;
          margin: 0 13px;

          height: 45px;
        }
        .bb1{
          border-bottom: 1px solid #dadada;
        }
      }
      .info-input {
        overflow: hidden;
        padding: 0 13px;

        height: 45px;
        border: 1px solid #b0b0b0;
        border-radius: 5px;
      }
      .info-icon {
        width: 18px;
        height: 18px;
      }
      .close-icon {
        width: 18px;
        height: 18px;
      }
      .code-tip {
        margin-left: auto;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(0, 48, 120, 1);
      }
      input {
        border: none;
      }
      textarea {
        width: 100%;
        height: 66px;
        background: rgba(245, 246, 247, 1);
        opacity: 0.5;
        border-radius: 5px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        padding: 15px;
      }
    }
    .op-btn {
      width: 315px;
      height: 44px;
      background: rgba(0, 48, 120, 1);
      border-radius: 22px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 44px;
      margin: 15px auto;
    }
  }
}
.van-cell {
  background: transparent;
}
.checkbox {
  margin-bottom: 6px;
  .checkbox-text {
    font-size: 14px;
    span {
      font-weight: 700;
    }
  }
}
</style>